import React from 'react'

import {
  FieldSpec,
  PaginatedTable,
  RelatedLinkedField,
  ValueField,
} from 'src/components/Table'
import { ListTableProps } from './types'

const fieldOptions: { [key:string]: FieldSpec } = {
  unit: { id: 'unit', label: 'Name', renderer: RelatedLinkedField(ValueField, 'name') },
  product: {
    id: 'unit.product',
    label: 'Product',
    ordering: 'unit__product__name',
    renderer: RelatedLinkedField(ValueField, 'name'),
  },
}

export const ParcelOrderBarcodedUnitListTable = (props: ListTableProps) => {
  const { paginator, title, fields } = props

  return (
    <>
      <PaginatedTable
        title={title || 'Barcoded Units'}
        fields={fields.map((field) => fieldOptions[field])}
        paginator={paginator}
      />
    </>
  )
}
